// src/modules/profile/components/CurrentCompetitionsCard/index.js
import React from 'react';
import { Card, Badge, ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import './styles.css';

const CurrentCompetitionsCard = ({ currentCompetitions }) => {
    return (
        <Card className="current-competitions-card">
            <Card.Header className="d-flex align-items-center justify-content-between">
                <h5 className="mb-0">
                    <i className="bi bi-flag-fill me-2 text-primary"></i>
                    Active Competitions
                </h5>
                <Badge bg="primary">{currentCompetitions?.length || 0}</Badge>
            </Card.Header>
            <ListGroup variant="flush">
                {currentCompetitions && currentCompetitions.length > 0 ? (
                    currentCompetitions.map(comp => (
                        <ListGroup.Item key={comp.competitionId} className="p-0">
                            <Link to={`/competition/${comp.competitionId}`} className="comp-item-link">
                                <div className="comp-item">
                                    <div className="comp-info">
                                        <div className="comp-name">{comp.name}</div>
                                        {comp.startDate && comp.endDate && (
                                            <div className="comp-meta text-muted">
                                                {new Date(comp.startDate).toLocaleDateString()} – {new Date(comp.endDate).toLocaleDateString()}
                                            </div>
                                        )}
                                    </div>
                                    <div className="comp-points">
                                        <strong>{comp.points !== undefined && comp.points !== null ? comp.points.toFixed(1) : '0'}</strong> pts
                                    </div>
                                </div>
                            </Link>
                        </ListGroup.Item>
                    ))
                ) : (
                    <ListGroup.Item className="text-center text-muted py-4">
                        <i className="bi bi-flag d-block mb-2" style={{ fontSize: '1.5rem' }}></i>
                        Not participating in any active competitions
                    </ListGroup.Item>
                )}
            </ListGroup>
        </Card>
    );
};

CurrentCompetitionsCard.propTypes = {
    currentCompetitions: PropTypes.arrayOf(PropTypes.shape({
        competitionId: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        points: PropTypes.number,
        startDate: PropTypes.string,
        endDate: PropTypes.string
    }))
};

export default CurrentCompetitionsCard;
